import Penpal from 'penpal';
import { useLocation } from 'react-router-dom';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from '@/lib/axios';
import { useEffect } from 'react';
import { useAuth } from '@/lib/auth';
import { useGetUserDetails } from '@/features/settings/api/getUserDetails';

export const useIframeStore = create(
  immer(() => ({
    isAppInIframe: false,
    iframeAccessTokenGenerating: false,
    iframeAccessToken: '',
    updateUrl: () => {},
    redirectBasedOnParams: () => {},
  }))
);

const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);
const embed = params.get('embed');

if (embed === 'true' && window.top !== window.self) {
  // app loaded in iframe
  const connection = Penpal.connectToParent();
  connection.promise.then(async (parent) => {
    // penpal connection established
    useIframeStore.setState({
      isAppInIframe: true,
      iframeAccessTokenGenerating: true,
      updateUrl: parent.updateUrl,
      redirectBasedOnParams: parent.redirectBasedOnParams,
    });
    const session_id = params.get('session_id');
    try {
      if (!session_id) throw new Error('Session id is missing');
      const data = await axios.post('/api/v1/auth/iframe-login', {
        sessionURL: decodeURIComponent(session_id),
      });
      useIframeStore.setState({
        iframeAccessTokenGenerating: false,
        iframeAccessToken: data.access_token,
      });
    } catch (error) {
      useIframeStore.setState({
        iframeAccessTokenGenerating: false,
      });
      throw error;
    }
  });
}

export default function useIframe() {
  const iframe = useIframeStore();
  const location = useLocation();
  const locationRef = useAuth();

  useGetUserDetails({
    config: {
      enabled: Boolean(iframe.isAppInIframe && iframe.iframeAccessToken),
      staleTime: Infinity,
    },
  });

  useEffect(() => {
    if (
      iframe.isAppInIframe &&
      typeof iframe.updateUrl === 'function' &&
      locationRef.current !== location.pathname
    ) {
      locationRef.current = location.pathname;
      iframe.updateUrl(location.pathname);
    }
  }, [iframe.isAppInIframe, location.pathname]);

  return iframe;
}
